<template>
  <v-container class="news-form">
    <v-form ref="form" v-model="valid" :lazy-validation="false">
      <v-row>
        <v-col cols="3">
          標題
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="form.title"
            label="標題"
            :rules="titleRule"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          活動開始日期
        </v-col>
        <v-col cols="9" md="6">
          <date-time-picker
            label="活動開始日期"
            v-model="form.startTime"
            :rules="dateRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          活動結束日期
        </v-col>
        <v-col cols="9" md="6">
          <date-time-picker
            label="活動結束日期"
            v-model="form.endTime"
            :rules="dateRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">活動內容</v-col>
        <v-col cols="9">
          <v-textarea
            solo
            v-model="form.description"
            name="input-7-6"
            :rules="contentRule"
            label="活動內容"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">活動連結</v-col>
        <v-col cols="9">
          <v-text-field v-model="form.url" label="活動連結"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">網頁用活動連結</v-col>
        <v-col cols="9">
          <v-text-field v-model="form.urlForWeb" label="網頁用活動連結"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">活動圖片
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="black" small dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>尺寸比例為 1920*1020</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
          <v-file-input
            :rules="fileRule"
            @click:clear="handleClearImage"
            @change="changeImage($event)"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="上傳圖片"
            prepend-icon="mdi-camera"
            label="活動圖片"
          ></v-file-input>
        </v-col>
        <v-col cols="5">
          <img :src="eventPic" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">網頁用寬圖
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="black" small dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>尺寸比例為 1200*200</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
          <v-file-input
            @click:clear="handleClearWebImage"
            @change="changeWebImage($event)"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="上傳網頁用寬圖"
            prepend-icon="mdi-camera"
            label="網頁用寬圖"
          ></v-file-input>
        </v-col>
        <v-col cols="5">
          <img :src="form.picForWeb" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="start">站別</v-col>
        <v-col cols="9" class="text-left">
          <flag-picker
            :items="siteTypes"
            labelField="text"
            valueField="value"
            v-model="form.siteType"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">
          <v-btn class="mr-4" @click="handleBack"> 取消 </v-btn>
          <v-btn class="mr-4" @click="handleSubmit"> 確認 </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import FlagPicker from '@/components/FlagPicker.vue';
import api from '@/api';
import imageConvert from '@/utils/image';
import ruleMixin from '@/minix/ruleMixin';
import DateTimePicker from '@/components/DateTimePicker.vue';
import moment from 'moment';

export default {
  mixins: [ruleMixin],
  components: {
    DateTimePicker,
    FlagPicker,
  },
  data() {
    return {
      valid: true,
      form: {
        startTime: '',
        endTime: '',
        title: '',
        pic: '',
        picForWeb: '',
        description: '',
        url: '',
        siteType: 1,
      },
      eventPic: '',
      siteTypes: [
        { text: 'Web', value: 1 },
        { text: 'Blog', value: 2 },
        { text: 'App', value: 4 },
      ],
      titleRule: this.requiredRule('標題'),
      dateRule: this.requiredRule('日期'),
      contentRule: this.requiredRule('內容'),
    };
  },
  async created() {
    if (this.isEdit) {
      this.getEventInfo();
    }
  },
  computed: {
    isEdit() {
      return this.$route.name === 'event-edit';
    },
    eventId() {
      return this.$route.params.eventId;
    },
    fileRule() {
      return [
        (v) => !!v || !!this.eventPic || '圖片 為必填',
        (value) => !value || value.size < 4000000 || '照片大小不可大於 4 MB!',
      ];
    },
  },
  methods: {
    async getEventInfo() {
      const { data } = await api.event.eventInfo(this.eventId);
      this.form = {
        ...data,
        startTime: moment(data.startTime).format('YYYY-MM-DD HH:mm'),
        endTime: moment(data.endTime).format('YYYY-MM-DD HH:mm'),
      };
      this.eventPic = data.pic;
    },
    handleClearImage() {
      this.form.pic = '';
    },
    handleClearWebImage() {
      this.form.picForWeb = '';
    },
    changeImage(event) {
      if (event) {
        this.form.pic = event;
        this.eventPic = URL.createObjectURL(event);
      }
    },
    async changeWebImage(event) {
      if (event) {
        const base64 = await imageConvert(event);
        this.form.picForWeb = base64;
      }
    },
    handleBack() {
      this.$router.push({
        name: 'event-list',
        query: { ...this.$route.query },
      });
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      const submitForm = {
        ...this.form,
        pic: await imageConvert(this.form.pic),
      };
      let result;
      if (this.isEdit) {
        result = await api.event.edit({
          ...submitForm,
          eventId: this.eventId,
        });
      } else {
        result = await api.event.add(submitForm);
      }
      const { status } = result;
      if (status === 1) this.handleBack();
    },
  },
};
</script>

<style scoped lang="scss">
.news-form {
  img {
    width: 100%;
  }
}
</style>
